import React, { Fragment } from 'react'
import { Button, Card, CardHeader, CardBody, CardFooter, CardImg, Spinner, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { ArrowLineDown, Printer, ShareNetwork, ArrowLeft } from "phosphor-react"
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { processError } from '../../lib/lib'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import {
    FacebookIcon,
    FacebookShareButton,
    HatenaShareButton,
    HatenaIcon,
    OKShareButton,
    OKIcon,
    PinterestShareButton,
    PinterestIcon,
    RedditShareButton,
    RedditIcon,
    TumblrIcon,
    TumblrShareButton,
    VKIcon,
    VKShareButton,
} from "react-share"
const cookies = new Cookies()

class Certificate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
            file: '',
            image: '',
            loading: true,
            success: -1,
            shareModal: false,
        }
        this.print = this.print.bind(this)
        this.pictureLoaded = this.pictureLoaded.bind(this)
        this.share = this.share.bind(this)
    }

    async componentWillMount() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const courseId = this.props.match.params.courseId
        api.profileInfo(token)
            .then(({ data: { profileFirstName, profileLastName } }) => {
                const userName = `${profileFirstName} ${profileLastName}`
                api.getCourseSuccessComplete({ token, lang, courseId, userName })
                    .then(({ data: { file, image, success, status } }) => {
                        if (status === 'not needed') this.setState({ file, image: '', success: success ? 1 : 0, loading: false })
                        else this.setState({ file, image, success: success ? 1 : 0 })
                    })
                    .catch((e) => processError(e, this.props.history))
            })
            .catch((e) => processError(e, this.props.history))
    }

    download(url, filename) {
        fetch(url)
            .then((response) => response.blob())
            .then((blob) => {
                const link = document.createElement("a")
                link.href = URL.createObjectURL(blob)
                link.download = filename
                link.click()
            })
            .catch(console.error)
    }

    share() {
        this.setState({ shareModal: true })
    }

    print() {
        window.open(`${this.state.imageUrl}/certificates/${this.state.file}`, "_blank")
    }

    pictureLoaded() {
        this.setState({ loading: false })
    }

    render() {
        const { t } = this.props
        return (
            <div className="certificate-wrapper">
                <Modal isOpen={this.state.shareModal} toggle={() => this.setState({ shareModal: false })} centered={true} className='certificate-modal'>
                    <ModalHeader>
                        <div className="modal-title h4">{t('certificate-share')}</div>
                    </ModalHeader>
                    <ModalBody>
                        <FacebookShareButton url={`${this.state.imageUrl}/certificates/${this.state.image}`}>
                            <FacebookIcon />
                        </FacebookShareButton>
                        <HatenaShareButton url={`${this.state.imageUrl}/certificates/${this.state.image}`}>
                            <HatenaIcon />
                        </HatenaShareButton>
                        <OKShareButton url={`${this.state.imageUrl}/certificates/${this.state.image}`}>
                            <OKIcon />
                        </OKShareButton>
                        <PinterestShareButton url={`${this.state.imageUrl}/certificates/${this.state.image}`}>
                            <PinterestIcon />
                        </PinterestShareButton>
                        <RedditShareButton url={`${this.state.imageUrl}/certificates/${this.state.image}`}>
                            <RedditIcon />
                        </RedditShareButton>
                        <TumblrShareButton url={`${this.state.imageUrl}/certificates/${this.state.image}`}>
                            <TumblrIcon />
                        </TumblrShareButton>
                        <VKShareButton url={`${this.state.imageUrl}/certificates/${this.state.image}`}>
                            <VKIcon />
                        </VKShareButton>
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="secondary" onClick={() => this.setState({ shareModal: false })}>{t('certificate-close')}</Button>
                    </ModalFooter>
                </Modal>
                {
                    this.state.success === 1 ?
                        <Card className="nostudy-card m-0">
                            <CardHeader className="d-flex align-items-center flex-column">
                                <span className="title lg-font-size">{t(`certificate-congrats${this.state.image ? '' : '-course'}`)}</span>
                                <span className="subtitle md-font-size">{t(`cartificate-confirm${this.state.image ? '' : '-course'}`)}</span>
                                <span>{t('certificate-keep-on')}</span>
                            </CardHeader>
                            <CardBody className="d-flex justify-content-center">
                                <Spinner
                                    className={this.state.loading ? '' : 'd-none'}
                                    as="span"
                                    animation="grow"
                                    style={{ width: '3rem', height: '3rem' }}
                                    role="status"
                                    aria-hidden="true"
                                />
                                {
                                    this.state.image ?
                                        <CardImg
                                            className={`certificate-img ${this.state.loading ? 'd-none' : ''}`}
                                            src={`${this.state.imageUrl}/certificates/${this.state.image}`}
                                            onLoad={this.pictureLoaded}
                                            onClick={this.print}
                                        /> : ''
                                }
                            </CardBody>
                            <div className="horizontal-whitespace"></div>
                            <CardFooter className="d-flex justify-content-end">
                                <Button className="ptimary" onClick={() => this.props.history.push('/study')}>
                                    <span className="text sm-font-size">{t('certificate-to-study')}</span>
                                </Button>
                            </CardFooter>
                            {
                                this.state.image ?
                                    <Fragment>
                                        <div className="horizontal-whitespace"></div>
                                        <CardFooter>
                                            <div className='d-flex flex-column certificate-buttons'>
                                                <div className="d-flex justify-content-between align-items-center my-3">
                                                    <Button className="ptimary" onClick={() => this.download(`${this.state.imageUrl}/certificates/${this.state.file}`, this.state.file)}>
                                                        <ArrowLineDown size={20} className='mr-2' />
                                                        <span className="text sm-font-size">{t('certificate-save')}</span>
                                                    </Button>
                                                    <Button className="secondary" onClick={this.print}>
                                                        <Printer size={20} className='mr-2' color={'#7E7E7E'} />
                                                        <span className="text sm-font-size">{t('cartificate-print')}</span>
                                                    </Button>
                                                    <Button className="secondary" onClick={this.share}>
                                                        <ShareNetwork size={20} className='mr-2' color={'#7E7E7E'} />
                                                        <span className="text sm-font-size">{t('certificate-share')}</span>
                                                    </Button>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <Button className="ptimary" onClick={() => this.props.history.push('/study')}>
                                                        <ArrowLeft size={20} className='mr-2' />
                                                        <span className="text sm-font-size">{t('certificate-study')}</span>
                                                    </Button>
                                                </div>
                                            </div>
                                        </CardFooter>
                                    </Fragment> : ''
                            }
                        </Card> :
                        this.state.success === 0 ?
                            <Card className="nostudy-card m-0">
                                <CardHeader className="d-flex align-items-center flex-column">
                                    <span className="title lg-font-size">{t('certificate-non-exist')}</span>
                                </CardHeader>
                                <CardBody className="d-flex justify-content-center md-font-size">
                                    <span>{t('certificate-get-cert')}</span>
                                </CardBody>
                                <div className="horizontal-whitespace"></div>
                                <CardFooter className="d-flex justify-content-end">
                                    <Button className="ptimary" onClick={() => this.props.history.push('/study')}>
                                        <span className="text sm-font-size">{t('certificate-to-study')}</span>
                                    </Button>
                                </CardFooter>
                            </Card> :
                            <Card className="nostudy-card m-0">
                                <CardHeader className="d-flex align-items-center flex-column">
                                    <span className="title lg-font-size">{t('certificate-loading')}</span>
                                </CardHeader>
                                <CardBody className="d-flex justify-content-center">
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        style={{ width: '3rem', height: '3rem' }}
                                        role="status"
                                        aria-hidden="true"
                                    />
                                </CardBody>
                            </Card>
                }
            </div>
        )
    }
}

Certificate.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
}

export default withTranslation()(Certificate)



// WEBPACK FOOTER //
// ./src/views/Study/Certificate.jsx